import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FilRougePage } from './fil-rouge';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    FilRougePage,
  ],
  imports: [
    IonicPageModule.forChild(FilRougePage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
})
export class FilRougePageModule {}



// WEBPACK FOOTER //
// ./src/pages/fil-rouge/fil-rouge.module.ts